module.exports = __webpack_public_path__ + "static/assets/f0f5080715a3b44b0ddd9d75f7c6d17f.png";